import { createFeature, createReducer, on } from '@ngrx/store';
import { TopbarActions } from '../../actions/topbar/topbar.actions';
import { IMenuItem } from '@models/menu-item.model';
import { routerNavigatedAction, routerRequestAction } from '@ngrx/router-store';
import { menuItems } from '../../../constants/menu-items';

export const topbarFeatureKey = 'topbar';

export interface State {
  menuItems: IMenuItem[],
  pageLabel: string,
  currentIcon: string,
}

export const initialState: State = {
  menuItems: menuItems,
  pageLabel: "",
  currentIcon: ""
};

export const reducer = createReducer(
  initialState,
  on(TopbarActions.loadTopbars, state => state),
  on(routerNavigatedAction, (state, action) => {
    const currentRoute = action.payload.routerState.url;
    const currentItem = state.menuItems.find(item => item.route === currentRoute)
      ?? state.menuItems.find(item => item.route !== '/' && currentRoute.startsWith(item.route));
    return {
      ...state,
      pageLabel: currentItem ? currentItem.label : '',
      currentIcon: currentItem ? currentItem.icon : ''
    }
  })
);

export const topbarFeature = createFeature({
  name: topbarFeatureKey,
  reducer,
});

